import React, { useState } from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'

import Popup from 'reactjs-popup'

import chunk from 'lodash/chunk'
import size from 'lodash/size'

import ReactBnbGallery from 'react-bnb-gallery'


const Gallery = ({ photos, video }) => {
	const [isOpen, setIsOpen] = useState(false)
	const [activePhotoIndex, setActivePhotoIndex] = useState(0)
	const getFirst = chunk(photos, 5)
	const countFirst = getFirst[0] ? getFirst[0].length : null
	const toggleModal = counter => {
		setActivePhotoIndex(counter)
		setIsOpen(true)
	}
	const RenderThreeItems = ({ data }) => {
		return(
			<>
				<a onClick={() => toggleModal(0)} className={`md:border-r-10 border-black w-full md:w-1/2`}>
					{data[0]?.localFile?.childImageSharp &&
					<GatsbyImage image={data[0]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[0]?.altText || ''} className={`object-cover object-center w-full h-full`} />
					}
				</a>
				<div className={`w-full md:w-1/2 md:flex flex-col hidden`}>
					<a onClick={() => toggleModal(1)} className={`md:border-b-10 border-black w-full md:h-1/2`}>
						{
							data[1]?.localFile?.childImageSharp &&
							<GatsbyImage image={data[1]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[1]?.altText || ''} className={`object-cover object-center w-full h-full`} />
						}
					</a>
					<a onClick={() => toggleModal(2)} className={`w-full md:h-1/2`}>
						{ data[2]?.localFile?.childImageSharp &&
						<GatsbyImage image={data[2]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[2]?.altText || ''} className={`object-cover object-center w-full h-full`} />
						}
					</a>
				</div>
			</>
		)
	}


	const RenderFourItems = ({ data }) => {
		return(
			<>
				<a onClick={() => toggleModal(0)} className={`md:border-r-10 border-black w-full md:w-1/3`}>
					{
						data[0]?.localFile?.childImageSharp &&
						<GatsbyImage image={data[0]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[0]?.altText || ''} className={`object-cover object-center w-full h-full`} />
					}
				</a>
				<a onClick={() => toggleModal(1)} className={`md:border-r-10 border-black w-full md:w-1/3 hidden md:block`}>
					{
						data[1]?.localFile?.childImageSharp &&
						<GatsbyImage image={data[1]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[1]?.altText || ''} className={`object-cover object-center w-full h-full`} />
					}
				</a>
				<div className="w-full md:w-1/3 hidden md:flex flex-col">
					<a onClick={() => toggleModal(2)} className={`md:border-b-10 border-black w-full h-1/2`}>
						{
							data[2]?.localFile?.childImageSharp &&
							<GatsbyImage image={data[2]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[2]?.altText || ''} className={`object-cover object-center w-full h-full`} />
						}
					</a>
					<a onClick={() => toggleModal(3)} className={`w-full h-1/2`}>
						{ data[3]?.localFile?.childImageSharp &&
							<GatsbyImage image={data[3]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[3]?.altText || ''} className={`object-cover object-center w-full h-full`} />
						}
					</a>
				</div>

			</>
		)
	}

	const RenderFiveItems = ({data}) => {
		return(
			<>
				<a onClick={() => toggleModal(0)} className={`md:border-r-10 border-black w-full md:w-1/2`}>
					{ data[0]?.localFile?.childImageSharp && 
						<GatsbyImage image={data[0]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[0]?.altText || ''} className={`object-cover object-center w-full h-full`} />
					}
				</a>


				<div className="w-full md:w-1/2 hidden md:flex flex-wrap">
					<div className="w-full md:w-1/2 flex flex-col h-full">

						<a onClick={() => toggleModal(1)} className={`w-full h-1/2 md:border-r-10 md:border-b-10 border-black`}>
							{
								data[1]?.localFile?.childImageSharp && 
								<GatsbyImage image={data[1]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[1]?.altText || ''} className={`object-cover object-center w-full h-full`} />
							}
						</a>

						<a onClick={() => toggleModal(2)} className={`w-full md:border-r-10 border-black h-1/2`}>
							{
								data[2]?.localFile?.childImageSharp && 
								<GatsbyImage image={data[2]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[2]?.altText || ''} className={`object-cover object-center w-full h-full`} />
							}
						</a>

					</div>
					<div className="w-full md:w-1/2 flex flex-col h-full">

						<a onClick={() => toggleModal(3)} className={`w-full h-1/2 md:border-b-10 border-black`}>
							{data[3]?.localFile?.childImageSharp && 
								<GatsbyImage image={data[3]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[3]?.altText || ''} className={`object-cover object-center w-full h-full`} />
							}
						</a>

						<a onClick={() => toggleModal(4)} className={`w-full h-1/2`}>
							{
								data[4]?.localFile?.childImageSharp &&
								<GatsbyImage image={data[4]?.localFile?.childImageSharp?.gatsbyImageData} alt={data[4]?.altText || ''} className={`object-cover object-center w-full h-full`} />

							}
						</a>

					</div>
				</div>

			</>
		)
	}

	return (
		<div className="container max-w-full pb-6 lg:pb-12 pt-6 lg:pt-12">
			<div className={`overflow-hidden relative z-10 ${countFirst === 1 ? 'max-w-4xl mx-auto' : ''}`}>
					<div className="flex flex-wrap">
					{
						video?.mediaItemUrl && video?.mimeType && (typeof window !== "undefined") &&
	                      <Popup onOpen={() => {
	                      	const video = document.getElementById('videoHome')
	                      	if(video){
	                      		video.play()
	                      	}
	                      }} lockScroll={true} trigger={
	                      	<button className="z-50 flex items-center rounded-full px-5 py-2 text-sm bg-white cursor-pointer hover:bg-tan-100 hover:shadow-lg absolute left-0 bottom-0 m-5 lg:m-8">
	                      		Play video
	                      	</button>
	                      } modal>
	                      	{
	                      		close => (
			                        <div className="relative container mt-10 mb-16">
			                        	<div className="flex justify-end mb-3">
								        <button className="cursor-pointer text-white hover:text-tan-500 p-5 pr-0 rounded-full flex items-center" onClick={close}>
								          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current fill-current w-6 h-6 mx-auto" viewBox="0 0 16 16"><title>simple-remove</title><g strokeWidth="1"><line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="13.5" y1="2.5" x2="2.5" y2="13.5"></line> <line fill="none" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="2.5" y1="2.5" x2="13.5" y2="13.5"></line> </g></svg>
								        </button>
								        </div>
										<video id="videoHome" controls className="shadow-lg">
										    <source src={ video.mediaItemUrl } type={ video.mimeType } />

										    Sorry, your browser doesn't support embedded videos.
										</video>
			                        </div>
	                      		)
	                      	}

	                      </Popup>
					}

						{
							countFirst <= 2 &&
								getFirst[0]?.map((item, key) => {
									const counter = key+1

									if(countFirst === 1){
										return (
											<a href={item.src} onClick={() => toggleModal(counter)} key={key} className={`w-full`}>
												{ item?.localFile?.childImageSharp &&
												<GatsbyImage image={item?.localFile?.childImageSharp?.gatsbyImageData} alt={item?.altText || ''} className={`object-cover object-center w-full h-full`} />
												}
											</a>
										)
									}
									else if(countFirst === 2){
										const extra = counter === 2 ? 'hidden md:block' : ''
										return(
											<a href={item.src} onClick={() => toggleModal(counter)} key={key} className={`md:border-r-10 border-black w-full md:w-1/2 ${extra}`}>
												{ item?.localFile?.childImageSharp &&
												<GatsbyImage image={item?.localFile?.childImageSharp?.gatsbyImageData} alt={item?.altText || ''} className={`object-cover object-center w-full h-full`} />
												}
											</a>
										)
									}

								})

						}
						{
							countFirst === 3 &&
								<RenderThreeItems data={photos} />
						}
						{
							countFirst === 4 &&
								<RenderFourItems data={photos} />
						}
						{
							countFirst === 5 &&
								<RenderFiveItems data={photos} />
						}
					</div>
					{/* { video && video.mediaItemUrl && video.mimeType &&
						<button onClick={() => setIsOpen(true) } className="rounded-full px-5 py-2 text-sm bg-white cursor-pointer hover:bg-tan-100 hover:shadow-lg absolute left-0 bottom-0 m-5 lg:m-8">Play video</button>
					} */}
					{ !(video && video.mediaItemUrl && video.mimeType) &&
						<button onClick={() => setIsOpen(true) } className="rounded-full px-5 py-2 text-sm bg-white cursor-pointer hover:bg-tan-100 hover:shadow-lg absolute left-0 bottom-0 m-5 lg:m-8">View all</button>
					}

			</div>
		     <ReactBnbGallery
		     	backgroundColor={'#121212'}
		        show={isOpen}
		        photos={photos}
		        wrap={true}
		        activePhotoIndex={size(photos) > 1 ? activePhotoIndex : 0}
		        onClose={() => setIsOpen(false)}
		    />

	    </div>
	)
}

export default Gallery;
